import { ReplaceInfo } from './substituteValue'

export const processReplacement = (
  str: string,
  values: Record<string, string> = {},
  replacementData: Record<string, ReplaceInfo>
) => {
  if (Object.keys(replacementData).includes(str)) {
    const replacementType = replacementData[str].type
    const keyName = replacementData[str]['key']
    const text = replacementData[str]['text']

    switch (replacementType) {
      case 'link':
        if (text) {
          return text
        } else {
          break
        }
      default:
        if (keyName && values[keyName]) {
          if (keyName === 'firstname1') {
            const capitalizedValue =
              values[keyName][0].toUpperCase() + values[keyName].slice(1)
            return capitalizedValue
          } else {
            return values[keyName]
          }
        } else if (text) {
          return text
        } else {
          break
        }
    }
  }

  return str
}
